import * as React from 'react';
import { fetchBanner } from './api'

export const Config = {
  State: {
    initial: 'initial',
    loaded: 'loaded',
    broken: 'broken',
  },
  Banner: {
    Format: {
      image: 'image',
      video: 'video',
    }
  },
  Routing: {
    model: (id) => `/banners/${id}.json`
  }
};

export function useFetchBannerInfo(bannerID) {
  const [currentState, setCurrentState] = React.useState(Config.State.initial);
  const [banner, satBanner] = React.useState({});
  const [title, setTitle] = React.useState('');
  const [html, setHtml] = React.useState('');
  const [cta, setCta] = React.useState('');
  const [url, setUrl] = React.useState('');
  const [target, setTarget] = React.useState('');
  const [format, setFormat] = React.useState('');
  const [image, setImage] = React.useState('');
  const [links, setLinks] = React.useState([]);
  const [poster, setPoster] = React.useState(null);
  const [video, setVideo] = React.useState(null);

  React.useEffect(() => {
    const abortController = new AbortController();
    fetchBanner(bannerID, abortController)
      .then(([success, data]) => {
        if (!success) {
          setCurrentState(Config.State.broken);
          throw new Error(data)
        }
        satBanner(data);
        setCurrentState(Config.State.loaded);
      })
      .catch(error => console.log(error));
  }, [bannerID]);

  React.useEffect(() => {
    const {
      title: bannerTitle = '',
      body: bannerBody = '',
      cta: bannerCta = '',
      url: bannerURL = '',
      target: bannerTarget = '',
      media_format: bannerFormat = '',
      social_channels: channels = [],
      image: bannerImages = {},
      video_url = null,
      poster_image_url = null,
    } = banner;

    setTitle(bannerTitle);
    setHtml(bannerBody);
    setCta(bannerCta);
    setUrl(bannerURL);
    setTarget(bannerTarget);
    setFormat(bannerFormat);
    setImage(bannerImages);

    setVideo(video_url);
    setPoster(poster_image_url);
    setLinks([]);

    if (channels && channels.length > 0) {
      const normalizedChannels = channels
        .sort((a, b) => a.position - b.position)
        .map(item => ({
          platform: item.platform,
          url: item.url
        }));

      setLinks(normalizedChannels);
    }

  }, [currentState]);

  return {currentState, banner, title, html, cta, url, target, format, image, links, poster, video}
}
